import axios from 'axios';

const rawApiUrl = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
const baseURL = rawApiUrl.replace(/\/api(\/v1)?\/?$/, '');

// Central Axios instance pointing to the FastAPI backend API
export const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to inject Authorization headers when token is present
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('cinescope_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
